import authService from './authService';

const AGENT_PARENT_API_URL = process.env.REACT_APP_AGENT_PARENT_API_URL || 'https://your-agent-parent-api-url.execute-api.us-east-1.amazonaws.com/prod';

const promptsService = {
  /**
   * Get all prompts for the current user
   */
  async getPrompts() {
    try {
      // API Gateway Cognito authorizers use ID tokens, not access tokens
      const idToken = await authService.getIdToken();
      
      if (!idToken) {
        throw new Error('No ID token available');
      }

      const response = await fetch(`${AGENT_PARENT_API_URL}/prompts`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to fetch prompts');
      }

      const data = await response.json();
      return data.prompts || [];
    } catch (error) {
      console.error('Error fetching prompts:', error);
      throw error;
    }
  },

  /**
   * Add or update a prompt
   */
  async putPrompt(promptName, promptText) {
    try {
      const idToken = await authService.getIdToken();
      
      if (!idToken) {
        throw new Error('No ID token available');
      }

      const response = await fetch(`${AGENT_PARENT_API_URL}/prompts`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`,
        },
        body: JSON.stringify({
          promptName,
          promptText,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to save prompt');
      }

      return await response.json();
    } catch (error) {
      console.error('Error saving prompt:', error);
      throw error;
    }
  },

  /**
   * Delete a prompt
   */
  async deletePrompt(promptName) {
    try {
      const idToken = await authService.getIdToken();
      
      if (!idToken) {
        throw new Error('No ID token available');
      }

      const response = await fetch(`${AGENT_PARENT_API_URL}/prompts?promptName=${encodeURIComponent(promptName)}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to delete prompt');
      }

      return await response.json();
    } catch (error) {
      console.error('Error deleting prompt:', error);
      throw error;
    }
  },
};

export default promptsService;
